export default __webpack_public_path__ + "static/media/EF-Initials.1589194e.png";